module.exports = __webpack_public_path__ + "img/20201117.b63c8722.png";